export default __webpack_public_path__ + "static/six-76bed5ef78fbd74701e378bf8468cc06.jpg";